<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'

  type Props = {
    matchDesktop?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    matchDesktop: false,
  })

  const { t } = useI18n()
</script>

<template>
  <div
    class="c-pro-section"
    :class="{ 'match-desktop': props.matchDesktop }"
  >
    <div class="wrapper">
      <p class="paragraph-1">
        {{ t("home.pro-text-1-start") }}
        <strong>{{ t("home.pro-text-1-bold") }}</strong>
        {{ t("home.pro-text-1-end") }}
      </p>
      <div class="highlights">
        <div>
          <span class="highlight-large">{{ t("home.pro-highlight-1") }}</span>
        </div>
        <div>
          <span class="highlight-small">{{ t("home.pro-highlight-2") }}</span>
        </div>
      </div>
      <p class="paragraph-2">
        {{ t("home.pro-text-2") }}
      </p>
      <div class="bottom-links">
        <ClientOnly>
          <NuxtLink to="?modal=contact&section=pro">
            <Button
              class="button-primary"
              type="primary"
            >
              <div>
                <div class="button-top">
                  {{ t("home.pro-button-1") }}
                </div>
                <div class="button-bottom">
                  {{ t("home.pro-button-1-sub") }}
                </div>
              </div>
            </Button>
          </NuxtLink>
        </ClientOnly>

        <NuxtLink
          class="secondary-link"
          to="/join-us"
        >
          <Button
            class="button-secondary"
            type="secondary"
          >
            {{ t("home.pro-button-2") }}
          </Button>
        </NuxtLink>
      </div>
    </div>
    <div class="illustration" />
  </div>
</template>
<style scoped>
.c-pro-section {
  position: relative;
  padding: 1.5rem;
  background-color: var(--color-secondary);
  color: white;

  .wrapper {
    position: relative;
    display: flex;
    overflow: hidden visible;
    max-width: 35rem;
    flex-direction: column;
    margin: 0 auto 1.5em;

    * {
      max-width: 30rem;
    }

    .paragraph-1 {
      display: block;
      max-width: 75%;
      margin-top: 1rem;
      color: var(--color-primary);
      font-family: Open-Sans, sans-serif;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
    }

    .highlights {
      display: flex;
      flex-direction: column;
      margin-top: 0.75rem;

      .highlight-large {
        padding: 0 0.25rem;
        background-color: white;
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.17;
      }

      .highlight-small {
        padding: 0 0.25rem;
        background-color: white;
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.4;
      }
    }

    .paragraph-2 {
      max-width: 80%;
      margin-top: 2rem;
      color: white;
      font-family: Open-Sans, sans-serif;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.47;
    }

    .bottom-links {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 2rem;

      .secondary-link {
        margin: auto;

        .button-secondary {
          text-transform: uppercase;
        }
      }

      .button-primary {
        display: flex;
        flex: 0;
        flex-direction: column;

        .button-top {
          color: white;
          letter-spacing: 1.04px;
        }

        .button-bottom {
          margin-top: 0.25em;
          color: var(--color-secondary);
        }
      }
    }
  }

  .illustration {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    width: 35%;
    height: 60vw;
    max-height: 100%;
    background-image: url("~/assets/illustrations/ok-hand.svg");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: 50vw;
    overflow-x: hidden;
    transform: translateY(-5%);
  }

  @media screen and (width >= 1024px) {
    .wrapper {
      width: calc(324px * 3);
      min-width: calc(324px * 3);

      .paragraph-2 {
        max-width: 50%;
      }
    }

    .illustration {
      right: 10rem;
      background-size: contain;
      transform: scale(1.2);
    }
  }
}

</style>
